var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudForm',{attrs:{"title":_vm.title,"labelSubmit":_vm.labelSubmit,"storeName":_vm.storeName,"parentStoreName":"Privacy","submit":_vm.submit,"status":_vm.status,"breadcrumbs":[
      {
        text: 'Configuración y politicas',
        disabled: false,
        href: '/admin/privacy'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: _vm.$route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]}},[_c('ValidationObserver',{ref:"validator",scopedSlots:_vm._u([{key:"default",fn:function({}){return [_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('ValidationProvider',{ref:"description",attrs:{"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('div',{staticClass:"label-base"},[_vm._v("Descripción")]),_c('v-textarea',{staticClass:"text-tarea-base legal-text-area-scroll pb-1",attrs:{"error-messages":errors,"solo":"","placeholder":"Descripción","hide-details":"auto","rows":_vm.dynamicRows},model:{value:(_vm.data.description),callback:function ($$v) {_vm.$set(_vm.data, "description", $$v)},expression:"data.description"}})]}}],null,true)})],1)],1)],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }